import { Base } from 'layouts'
import { Form } from '../Form'

import * as S from './styled'

export function PropertyEdit() {
  return (
    <Base>
      <S.GridContainer container>
        <Form />
      </S.GridContainer>
    </Base>
  )
}
